export default "__VITE_ASSET__NfkMf1ph__"